import { ScaleLoader } from "react-spinners";
import CardLayout from "../../../components/layouts/CardLayout";
import { InviteCard } from "./InviteCard";

export const InvitesCardsListing = ({ invites, loading, lang, openDeleteModal }) => {
    if (loading) return (
        <div className="flex justify-center items-center mt-6">
            <ScaleLoader color='#9F64DF' />
        </div>
    );

    return (
        <CardLayout title="invite-codes-title">
            <div className="grid grid-cols-1 gap-4">
                {invites?.data?.map((item) => (
                    <InviteCard
                        key={item._id}
                        item={item}
                        lang={lang}
                        openDeleteModal={openDeleteModal}
                    />
                ))}
            </div>
        </CardLayout>
    );
};


